import React from "react";
import {
  Box,
  Divider,
  Paper,
  Skeleton,
  Stack,
  Typography,
} from "convertupleads-theme";
import PageTitleBox from "../../../common/PageTitleBox";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const SkeletonPage = () => {
  return (
    <Paper elevation={0}>
      <PageTitleBox
        title={"Skeleton"}
        description={
          "Display a placeholder preview of your content before the data gets loaded to reduce load-time frustration."
        }
      />
      <Divider light />
      <Box p={3}>
        <Typography variant={"h6"} color={"text.primary"}>
          Four types of skeleton - text, circular, rectangular and rounded.
        </Typography>

        <Box sx={{ width: "80%", marginInline: " auto", p: 3 }}>
          <PreviewAndEditor
            language={"js"}
            value={
              "                 <Skeleton variant=\"text\" sx={{ fontSize: '1rem' }} />\n" +
              "\n" +
              "                {/* For other variants, adjust the size with `width` and `height` */}\n" +
              '                <Skeleton variant="circular" width={40} height={40} />\n' +
              '                <Skeleton variant="rectangular" width={210} height={60} />\n' +
              '                <Skeleton variant="rounded" width={210} height={60} />'
            }
          >
            <Stack spacing={2}>
              <Skeleton variant="text" sx={{ fontSize: "1rem" }} />

              {/* For other variants, adjust the size with `width` and `height` */}
              <Skeleton variant="circular" width={40} height={40} />
              <Skeleton variant="rectangular" width={210} height={60} />
              <Skeleton variant="rounded" width={210} height={60} />
            </Stack>
          </PreviewAndEditor>
        </Box>
      </Box>

      <Box p={3}>
        <Typography variant={"h6"} color={"text.primary"}>
          Skeleton animations
        </Typography>

        <Box sx={{ width: "80%", marginInline: " auto", p: 3 }}>
          <PreviewAndEditor
            language={"js"}
            value={
              "<Skeleton /> {/* default pulse */}\n" +
              '<Skeleton animation="wave" />\n' +
              "<Skeleton animation={false} />"
            }
          >
            <Stack spacing={2}>
              <Skeleton width={210} /> {/* default pulse */}
              <Skeleton animation="wave" width={210} />
              <Skeleton animation={false} width={210} />
            </Stack>
          </PreviewAndEditor>
        </Box>
      </Box>
    </Paper>
  );
};

export default SkeletonPage;
